import { render, staticRenderFns } from "./EmojiOrIcon.vue?vue&type=template&id=335c864d&scoped=true&"
import script from "./EmojiOrIcon.vue?vue&type=script&lang=js&"
export * from "./EmojiOrIcon.vue?vue&type=script&lang=js&"
import style0 from "./EmojiOrIcon.vue?vue&type=style&index=0&id=335c864d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335c864d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335c864d')) {
      api.createRecord('335c864d', component.options)
    } else {
      api.reload('335c864d', component.options)
    }
    module.hot.accept("./EmojiOrIcon.vue?vue&type=template&id=335c864d&scoped=true&", function () {
      api.rerender('335c864d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/EmojiOrIcon.vue"
export default component.exports